import { render } from "./FloatBtn.vue?vue&type=template&id=1bccf14c"
import script from "./FloatBtn.vue?vue&type=script&lang=js"
export * from "./FloatBtn.vue?vue&type=script&lang=js"

import "./FloatBtn.vue?vue&type=style&index=0&id=1bccf14c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__